import { render } from "./fileIcon.vue?vue&type=template&id=1080247c&scoped=true"
import script from "./fileIcon.vue?vue&type=script&lang=js"
export * from "./fileIcon.vue?vue&type=script&lang=js"

import "./fileIcon.vue?vue&type=style&index=0&id=1080247c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1080247c"]])

export default __exports__